import { supabase } from '@/lib/supabase';

/**
 * DBからroles取得
 * @param {Object} role
 * @returns {Object} ロール一覧
 */
export async function getRoles() {
  try {
    const { data, error } = await supabase.from('roles').select('id,name');

    if (error) {
      throw error;
    } else {
      return data;
    }
  } catch (error) {
    console.error('Error fetching roles:', error);
    return;
  }
}
